import { MoreMenu } from "datastake-daf/dist/components";
import { renderAccessibility } from "../../../helper";

export const selectFiltersConfig = {};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

export const data = [
  {
    id: 'STK000000001',
    datastakeId: 'STK000000001',
    key: 'STK000000001',
    origin: 'IMS-SIF',
    version: 1,
    points: 6,
    source: 'Iron Mine',
    accessibility: 'acquired',
  },
  {
    id: 'STK000000002',
    datastakeId: 'STK000000002',
    key: 'STK000000002',
    origin: 'Arm',
    version: 1,
    points: 6,
    source: 'Hive',
    accessibility: 'custom',
  },
  {
    id: 'STK000000003',
    datastakeId: 'STK000000003',
    key: 'STK000000003',
    origin: 'MMT',
    points: 6,
    source: 'MMN',
    accessibility: 'uponAcceptance',
  },
  {
    id: 'STK000000004',
    datastakeId: 'STK000000004',
    key: 'STK000000004',
    origin: 'MMT',
    points: 6,
    version: 1,
    source: 'Justice Plus',
    accessibility: 'available',
  },
  {
    id: 'STK000000005',
    datastakeId: 'STK000000005',
    key: 'STK000000005',
    origin: 'MMT',
    points: 6,
    source: 'Lorem Ipsum',
    accessibility: 'uponPayment',
  },
  {
    id: 'STK000000006',
    datastakeId: 'STK000000006',
    key: 'STK000000006',
    origin: 'MMT',
    points: 6,
    source: 'Lorem Ipsum',
    accessibility: 'private',
  },
]

export const scpData = [
  {
    id: 'STK000000001',
    datastakeId: 'STK000000001',
    key: 'STK000000001',
    origin: 'IMS-SIF',
    version: 1,
    points: 6,
    source: 'Gesagu',
    accessibility: 'acquired',
  },
  {
    id: 'STK000000002',
    datastakeId: 'STK000000002',
    key: 'STK000000002',
    origin: 'Arm',
    version: 1,
    points: 6,
    source: 'Hive',
    accessibility: 'custom',
  },
  {
    id: 'STK000000003',
    datastakeId: 'STK000000003',
    key: 'STK000000003',
    origin: 'MMT',
    points: 6,
    source: 'MMN',
    accessibility: 'uponAcceptance',
  },
  {
    id: 'STK000000004',
    datastakeId: 'STK000000004',
    key: 'STK000000004',
    origin: 'MMT',
    points: 6,
    version: 1,
    source: 'Justice Plus',
    accessibility: 'available',
  },
  {
    id: 'STK000000005',
    datastakeId: 'STK000000005',
    key: 'STK000000005',
    origin: 'MMT',
    points: 6,
    source: 'Lorem Ipsum',
    accessibility: 'uponPayment',
  },
  {
    id: 'STK000000006',
    datastakeId: 'STK000000006',
    key: 'STK000000006',
    origin: 'MMT',
    points: 6,
    source: 'Lorem Ipsum',
    accessibility: 'private',
  },
]

export const columnsConfig = ({
  mod,
  id,
  user = {},
  t = (s) => s,
  goTo = () => { },
  onGetData = () => { },
  onViewSettings = () => { },
}) => [
    {
      title: t('Source'),
      dataIndex: 'source',
      key: 'source',
      ellipsis: true,
      render: (v) => v?.name || '',
    },
    {
      title: t('Origin'),
      dataIndex: 'origin',
      key: 'origin',
      ellipsis: true,
    },
    {
      title: t('Accessibility'),
      dataIndex: 'accessibility',
      key: 'accessibility',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const isOwn = !!all?.channels?.find((it) => it.inbound === user.company?.id && it.outbound === user.company?.id);
        if (isOwn) {
          return renderAccessibility({ val: 'own', t })
        }

        const isAcquired = !!all?.channels?.find((it) => it.inbound === user.company?.id);
        if (isAcquired) {
          return renderAccessibility({ val: 'acquired', t })
        }

        return renderAccessibility({ val, t })
      },
    },
    {
      title: t('Data Points'),
      dataIndex: 'points',
      key: 'points',
      ellipsis: true,
    },
    {
      title: t('Versions'),
      dataIndex: 'version',
      key: 'version',
      ellipsis: true,
      render: (val, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return val ? val : <div className="undisclosed-label">{t('Undiclosed')}</div>
      }
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        const getDataDisabled = !!(val?.channels || [])
          .filter((it) => it.inbound === user.company?.id || it.outbound === user.company?.id)
          .find((it) => it.discoverability === 'private' || it.inbound === user.company?.id);

        const items = [
          {
            key: 'viewDetails',
            label: t('Details'),
            onClick: () => goTo(`/app/${mod}/find-information/${id}/${val.source?.id}`),
          }
        ];

        switch (val.accessibility) {
          case 'unrestricted':
            items.push({ key: 'getData', label: t('Get Data'), onClick: () => onGetData(val), disabled: getDataDisabled });
            break;
          default:
        }

        items.push({ key: 'viewSettings', label: t('Disclosure Settings'), onClick: () => onViewSettings(val) });

        return (
          <MoreMenu items={items} />
        );
      },
      ellipsis: true,
    },
  ]
